/**
 * by Aleksandar Panic
 **/
import {sendGet} from "./base";

export function getAssignedApplications() {
    return sendGet('app/assigned');
}